import React from 'react';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';

import MainLayout from 'shared/layouts/MainLayout';
import { fetchRatings } from 'shared/services/trustedShops/fetchRatings';
import { Ratings } from 'shared/services/trustedShops/model';
import Hero from 'static_pages/foodProgram/Hero';
import WhatIsFoodProgram from 'static_pages/foodProgram/WhatIsFoodProgram';

const FooterLinks = dynamic(
  () => import('static_pages/components/FooterLinks')
);
const Advantages = dynamic(() => import('static_pages/foodProgram/Advantages'));
const BottomCTA = dynamic(() => import('static_pages/foodProgram/BottomCTA'));
const Companies = dynamic(() => import('static_pages/foodProgram/Companies'));
const CustomerExamples = dynamic(
  () => import('static_pages/foodProgram/CustomerExamples')
);
const FAQs = dynamic(() => import('static_pages/foodProgram/FAQs'));
const FindTheRightProgram = dynamic(
  () => import('static_pages/foodProgram/FindTheRightProgram')
);
const FoodProgramSteps = dynamic(
  () => import('static_pages/foodProgram/FoodProgramSteps')
);
const NumericHighlights = dynamic(
  () => import('static_pages/foodProgram/NumericHighlights')
);
const OurServices = dynamic(
  () => import('static_pages/foodProgram/OurServices')
);

type Props = {
  ratings: Ratings;
};

const FoodProgramPage = ({ ratings }: Props) => {
  const { t } = useTranslation('food_program');

  return (
    <MainLayout ratings={ratings} renderNavbarCta={() => null}>
      <Head>
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
      </Head>

      <Hero ratings={ratings} />
      <WhatIsFoodProgram mt={{ xs: 3, sm: 9 }} mb={{ xs: 4, sm: 9 }} />
      <OurServices mt={{ xs: 3, sm: 9 }} mb={{ xs: 10, sm: 15 }} />
      <Companies mb={{ xs: 10, md: 15 }} />
      <FindTheRightProgram mb={21} />
      <Advantages mb={9} />
      <NumericHighlights mb={11} />
      <CustomerExamples mb={{ xs: 5, md: 15 }} />
      <FoodProgramSteps mb={{ xs: 6, md: 15 }} />
      <FAQs mb={{ xs: 4, md: 9 }} />
      <BottomCTA mb={{ xs: 0, md: 8 }} />
      <FooterLinks pb={{ xs: 2, sm: 6 }} pt={{ xs: 2, sm: 3 }} />
    </MainLayout>
  );
};

export async function getStaticProps() {
  const ratings = await fetchRatings();
  return {
    props: {
      ratings,
      hasEnglishVersion: true,
    },
  };
}

export default FoodProgramPage;
